import React, { forwardRef, useCallback, useImperativeHandle, useState } from 'react'
import { Well } from '@pushly/aqe/lib/components'
import { RelativeDelayPicker } from './relative-delay-picker'
import { JourneyNode, NodeEditorRef, NodeEditorSubmitResult } from '../types/journey-nodes'
import type { IDelayStep, IDelayParams } from '@pushly/models/lib/structs/journeys'
import { updateStepConfig } from '@pushly/models/lib/structs/journeys'
import { JourneyBuilderMode } from '../enums/journey-builder-mode.enum'
import { useJourneyContext } from '../context'

type DelayEditorProps = {
    node: JourneyNode<IDelayStep>
}

export const DelayEditor = forwardRef<NodeEditorRef, DelayEditorProps>(({ node }, ref) => {
    const [state, _dispatch] = useJourneyContext()
    const [params, setParams] = useState<IDelayParams>(node.data.step.configuration.params)

    const handleDelayChange = useCallback(
        (changes: IDelayParams) => {
            setParams(changes)
        },
        [node],
    )

    useImperativeHandle(ref, () => ({
        onSubmit: (): NodeEditorSubmitResult => {
            return {
                nodeId: node.id,
                step: updateStepConfig(node.data.step, { params }),
            }
        },
    }))

    return (
        <>
            <Well mode="ghost" title="Schedule" hideFooter={true}>
                <RelativeDelayPicker
                    disabled={state.mode === JourneyBuilderMode.READONLY}
                    value={params}
                    onChange={handleDelayChange}
                />
            </Well>
        </>
    )
})
